export const cndLink = (src: string): string => {
  return `${process.env.CDNEndpoint}${src}`
}
